import { render } from "./IconX.vue?vue&type=template&id=57be2fc1"
import script from "./IconX.vue?vue&type=script&lang=js"
export * from "./IconX.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__